'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacebookIcon = function (_React$Component) {
    _inherits(FacebookIcon, _React$Component);

    function FacebookIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FacebookIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FacebookIcon.__proto__ || Object.getPrototypeOf(FacebookIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 43.466 43.466' },
                _react2.default.createElement(
                    'g',
                    { id: 'facebook_pink', 'data-name': 'facebook pink', transform: 'translate(-300.135 -629.33)', fill: 'transparent' },
                    _react2.default.createElement('path', { id: 'Path_3634', 'data-name': 'Path 3634', d: 'M332.552,629.33a21.733,21.733,0,1,0,21.736,21.731,21.758,21.758,0,0,0-21.736-21.731m5.408,22.5h-3.535v12.6h-5.24v-12.6h-2.492v-4.454h2.492v-2.881c0-2.061.979-5.287,5.287-5.287l3.881.016v4.323h-2.817a1.067,1.067,0,0,0-1.111,1.213v2.621h3.992Z', transform: 'translate(-10.687)', fill: primary })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FacebookIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 48;
            return _react2.default.createElement(
                _layout2.default,
                { size: size },
                this.getIcon(size, size, this.props.color)
            );
        }
    }]);

    return FacebookIcon;
}(_react2.default.Component);

exports.default = FacebookIcon;